import {Loader} from "@/customComponents/uiComponents/Loader.jsx";

// Soft-validation notice shown when the looked-up flight's airport doesn't match the
// selected pickup/dropoff airport. Renders nothing unless `flightMismatch`. Used by
// both the booking Smart Time step and the edit/confirm DateTimeSection.
export default function FlightMismatchWarning({flightMismatch, message, acknowledged, proceeding, onProceed}) {
    if (!flightMismatch) return null
    return (
        <div className="hopn-smart-time-date-warning hopn-flight-mismatch-warning error">
            {/* Inline (not <img>) so the stroke follows currentColor → red. */}
            <svg className="hopn-flight-mismatch-icon" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M8.83301 10.1667L13.177 13.4253C13.4461 13.6272 13.7816 13.7198 14.1162 13.6847C14.4507 13.6496 14.7597 13.4893 14.981 13.236L23.4997 3.5" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round"/>
                <path d="M24.833 12.8338C24.8331 15.3411 24.0477 17.7855 22.5872 19.8237C21.1267 21.8618 19.0645 23.3912 16.6902 24.1972C14.3159 25.0031 11.7488 25.0451 9.34941 24.3172C6.95002 23.5893 4.83891 22.1281 3.31257 20.1389C1.78624 18.1496 0.921363 15.7322 0.83942 13.2262C0.757478 10.7201 1.46258 8.25138 2.85571 6.16665C4.24883 4.08192 6.25998 2.48593 8.60669 1.60286C10.9534 0.71978 13.5178 0.593971 15.9397 1.2431" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round"/>
            </svg>
            <div className="hopn-flight-mismatch-content">
                <span>{message || "Your flight doesn't match your selected airport location."}</span>
                {!acknowledged && (
                    <button type="button" className="hopn-flight-mismatch-proceed" disabled={proceeding} onClick={onProceed}>
                        {proceeding ? <Loader color="#8b0000"/> : 'Proceed anyway'}
                    </button>
                )}
            </div>
        </div>
    )
}
